// 菜单
export default {
  'menu.login': '登陆',
  'menu.home': '首页',
  'menu.workplace': '工作台',
  'menu.setting': '个人设置',
  'menu.logout': '退出',
  'menu.setting.basic': '基本信息',
  'menu.setting.security': '安全设置',
  'menu.system': '系统设置',
  'menu.system.admin-list': '管理员列表',
  'menu.system.role-list': '角色列表',
  'menu.system.func-list': '功能列表',
  'menu.system.error-log-list': '错误日志',
  'menu.system.product-list': '商品列表',
  'menu.system.cache-manage': '缓存管理',
}